export default {"src":"/_next/static/media/dot_24.c8269ba7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};